import { render, staticRenderFns } from "./fangyitong.vue?vue&type=template&id=235c2c5f&scoped=true&"
import script from "./fangyitong.vue?vue&type=script&lang=js&"
export * from "./fangyitong.vue?vue&type=script&lang=js&"
import style0 from "./fangyitong.vue?vue&type=style&index=0&id=235c2c5f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235c2c5f",
  null
  
)

export default component.exports